<template>
  <section id="Popular" class="mt-1 mb-2">
    <div class="text-right cursor--pointer pr-1" @click="closeTab()">
      <i class="fa fa-times-circle"></i> Sulje
    </div>
    <div class="c-header--label text-white">Esittelyvideot</div>

    <div class="row">
      <div class="col-12 mb-1">
        <h5><a href="https://www.youtube.com/watch?v=fEPI4av3_h8&feature=youtu.be" target="_blank">Corolla Sedan</a></h5>
        <div class="support-text">14.1.2021</div>
      </div>
      <div class="col-12 mb-1">
        <h5><a href="https://www.youtube.com/watch?v=6Ct7XzJLmCg&feature=youtu.be" target="_blank">Corolla Touring Sports ja Hatchback</a></h5>
        <div class="support-text">14.1.2021</div>
      </div>
      <div class="col-12 mb-1">
        <h5><a href="https://www.youtube.com/watch?v=D_xHOxkNA58&feature=youtu.be" target="_blank">RAV4</a></h5>
        <div class="support-text">14.1.2021</div>
      </div>
      <div class="col-12 mb-1">
        <h5><a href="https://youtu.be/o9WucYx71hM" target="_blank">Yaris</a></h5>
        <div class="support-text">30.10.2020</div>
      </div>
      <div class="col-12 mb-1">
        <h5><a href="https://youtu.be/1S0r5OZoXcQ" target="_blank">Toyota C-HR</a></h5>
        <div class="support-text">31.1.2020</div>
      </div>
      <!--
      <div class="col-12 mb-1">
        <h5><a href="https://youtu.be/xiUrCeOcmHA" target="_blank">Prius</a></h5>
        <div class="support-text">22.6.2016</div>
      </div>
      <div class="col-12 mb-1">
        <h5><a href="https://youtu.be/QPCEQqb6_0I" target="_blank">Pro-varustelu ammattilaisille</a></h5>
        <div class="support-text">6.9.2016</div>
      </div>
      -->
      <div class="col-12 mb-1">
        <h5><a href="https://www.youtube.com/watch?v=tcCV46JYNcM&feature=youtu.be" target="_blank">Proace City ja Proace City Verso</a></h5>
        <div class="support-text">14.1.2021</div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'Videos',

  data () {
    return {
      form: {
        content: null
      }
    }
  },

  methods: {
    closeTab: function () {
      this.$emit('closeTab', true)
    }
  }
}
</script>
